import { render, staticRenderFns } from "./ShipmentStatus.vue?vue&type=template&id=109e0eaa&scoped=true&"
import script from "./ShipmentStatus.vue?vue&type=script&lang=ts&"
export * from "./ShipmentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentStatus.vue?vue&type=style&index=0&id=109e0eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e0eaa",
  null
  
)

export default component.exports